
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auto-loans",
      function () {
        return require("private-next-pages/auto-loans.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auto-loans"])
      });
    }
  